import 'isomorphic-fetch';
import { push } from 'react-router-redux';

import { displayNotification, hideLoginModal, showGlobalLoading, hideGlobalLoading } from 'Actions/UiActions';
import { trackGAEvent } from 'Actions/adsActions';
import { receiveCurrentUser } from 'Actions/UstateActions';
import { setCacheBuster } from 'Actions/MetaActions';
import {
	refreshPage, setGlobalNotification, resetAll,
	getFetchConfig
} from 'Actions/GlobalMetaActions';
import { getLandingPage } from 'Actions/UserSettingsActions';

import createHash from 'create-hash';

export function authenticate( data ) {

	return function(dispatch, getState) {
		const state = getState();
		const url = state.topifyPresets.forumSite.url;
		let config = {};

		dispatch( hideLoginModal() );
		dispatch( showGlobalLoading( 'Logging in' ) );

		if( data.social ) {
			dispatch( socialLogin( data ) );

		} else {
			let password = data.password;

			switch( state.topifyPresets.forumInfo.f_p_type ) {
				case 'md5':
					password = createHash( 'md5' ).update( data.password ).digest( 'hex' );
					break;
			}

			let body = `username=${ data.username }&password=${ password }&remember=true`;

			config = dispatch( getFetchConfig( true, 'POST', body ) );

			return fetch( `${url}?v=3.0&ajax=1&req=login`, config ).then( ( response ) => {
				dispatch( hideGlobalLoading() );

				if( !response.ok ) {
					try {
						response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, response );
						} ).catch( () => {
							setGlobalNotification( dispatch, {}, response );
						} );
					} catch( e ) {
						setGlobalNotification( dispatch, {}, response );
					}

				} else {
					response.json().then( ( json ) => {
						if( json.login ) {
							if( json.login.userName ) {
								let message = 'Welcome back, ' + json.login.userName + '!';
								displayNotification( 'success', message );
							}

							// Update user info if present
							if( json.ustate ) {
								dispatch( receiveCurrentUser( json.ustate ) );
							}

							// Record the Google Analytics event and for the forum.
							dispatch( trackGAEvent( true, 'forumLogin', 'userAction', 'security' ) );

							// Refresh the page
							dispatch( refreshPage() );
						}
					} )
				}
			} );
		}
	};
}

function socialLogin( data, url ) {
	return function( dispatch, getState ) {
		const state = getState();
		const url = state.topifyPresets.forumSite.url;
		// Record the Google Analytics event.
		dispatch( trackGAEvent( false, 'forumSocialStart', 'userAction', 'creation' ) );

		let currentUri = encodeURIComponent( state.routing.locationBeforeTransitions.pathname.replace( /^\//, '' ) );
		// We need to load the page directly
		window.location = `${url}?v=3.0&ajax=1&req=login&social=1&provider=${data.provider}&reg=1&uri=${currentUri}`;
	}
}

export function registerUserName( data ) {
	return function( dispatch, getState ) {
		const state = getState();
		const url = state.topifyPresets.forumSite.url;

		dispatch( showGlobalLoading( 'Registering new user' ) );

		// Update CacheBuster
		let cacheBust = new Date().getTime();
		dispatch( setCacheBuster( cacheBust ) );

		let pass = data.password ? `&password=${ data.password }` : '',
			uri = data.uri ? `&uri=${ encodeURIComponent( data.uri ) }` : '',
			body = `agree=${ data.agree }&provider=${ data.provider }&username=${ encodeURIComponent( data.username ) }${ pass }${ uri }`;

		let config = dispatch( getFetchConfig( true, 'POST', body ) );

		return fetch( `${url}?v=3.0&ajax=1&req=register`, config ).then( ( response ) => {
			dispatch( hideGlobalLoading() );

			if( !response.ok ) {
				try {
					response.json().then( ( json ) => {
						setGlobalNotification( dispatch, json, response );
					} ).catch( () => {
						setGlobalNotification( dispatch, {}, response );
					} );
				} catch( e ) {
					setGlobalNotification( dispatch, {}, response );
				}

			} else {
				response.json().then( ( json ) => {
					if( json.message && json.message.data && json.message.data.length ) {
						displayNotification( json.message.data[0].type, json.message.data[0].message );
					}

					if( json.login ) {
						// Record the Google Analytics event and for the forum.
						dispatch( trackGAEvent( true, 'forumRegister', 'userAction', 'security' ) );

						if( data.uri ) {
							// If we come from an URI go there
							dispatch( push( data.uri ) );
						} else {
							// Go to landing page
							let landingPage = dispatch( getLandingPage() );
							dispatch( push( landingPage ) );
						}
					}
				} )
			}
		} );

	}
}

export function checkUserName( name ) {
	return function( dispatch, getState ) {
		const state = getState();
		const url = state.topifyPresets.forumSite.url;

		let config = dispatch( getFetchConfig( true ) );

		return fetch( `${url}?v=3.0&ajax=1&object=reg_username&req=get&name=${ name }&_=${ new Date().getTime() }`, config ).then( ( response ) => {
			if( !response.ok ) {
				setGlobalNotification( dispatch, {}, response );
			} else {
				return response.json();
			}
		} ).then( json => {
				return {
					username: json.username,
					suggestedusername: json.suggestedusername
				};
			}
		);
	}
}

export function doLogout() {
	let url = this.props.forumSiteUrl + '?v=3.0&ajax=1&req=logout&_=' + Date.now();
	const config = this.props.dispatch( getFetchConfig( true ) );

	this.props.dispatch( showGlobalLoading( 'Logging out' ) );

	return fetch( url, config ).then( ( response ) => {
		this.props.dispatch( hideGlobalLoading() );
		if( !response.ok ) {
			try {
				response.json().then( ( json ) => {
					setGlobalNotification( dispatch, json, response );
				} ).catch( () => {
					setGlobalNotification( dispatch, {}, response );
				} );
			} catch( e ) {
				setGlobalNotification( dispatch, {}, response );
			}

		} else {
			displayNotification( 'success', 'You have been logged out' );
			response.json().then( ( json ) => {
				json.ustate.notifications = { pms: 0 };
				this.props.dispatch( resetAll() );
				this.props.dispatch( setCacheBuster( ( new Date().getTime() ) ) );
				this.props.dispatch( receiveCurrentUser( json.ustate ) );

				// Record the Google Analytics event.
				this.props.dispatch( trackGAEvent( false, 'forumLogout', 'userAction', 'security' ) );

				let landingPage = this.props.dispatch( getLandingPage() );
				try {
					if( this.props.routing.locationBeforeTransitions.pathname === landingPage ) {
						this.props.dispatch( refreshPage() );
					} else {
						throw true; // to Landing page
					}
				} catch( e ) {
					// Go to landing page
					this.props.dispatch( push( landingPage ) );
				}
			} );
		}
	} );
}



// WEBPACK FOOTER //
// ./src/actions/authenticateActions.js